import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { TabPanelPrimitive } from '../tabs-primitive/tab-panel-primitive.js';
import '../tabs-primitive/tab-primitive.js';
import '../tabs-primitive/tab-strip-primitive.js';
import 'react';
import 'tabbable';
import '../utils/interaction.js';
import { tabPanel, tabPanelFillWidth, tabPanelFillHeight } from './tabs.css.js';

/**
 * Used to add padding around multiple `Tab` elements
 *
 * @compose { "root": true }
 * @see https://fpl.figma.design/components/tabs/#tabtab-and-tabtabpanel
 */
function TabPanel(props) {
    const { width, height, ...otherProps } = props;
    return (jsx(TabPanelPrimitive, { "data-fpl-component": "", ...otherProps, className: clsx(tabPanel, {
            [tabPanelFillHeight]: height === 'fill',
            [tabPanelFillWidth]: width === 'fill',
        }) }));
}
TabPanel.displayName = 'Tabs.TabPanel';

export { TabPanel };
//# sourceMappingURL=tab-panel.js.map
